<template>
   <div class="flowInstanceApplyAction">
      <div class="box">
         <el-form :model="sendDataInfo" inline ref="sendDataInfo" label-width="130px" class="demo-ruleForm" :inline-message="false" :show-message="false">
            <el-form-item :label="item.fieldName" :prop="item.fieldName" v-for="(item, index) in formList" :key="index" :rules="item.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
               <label slot="label" :style="$common.labelStyle(item.fieldName)" v-html="$common.htmlLabel(item.fieldName)"></label>
               <div v-if="actionType == 0||actionType == 1">
                  <el-input clearable class="input" v-if="item.fieldType == 'number'" @input="calculate(1,item.fieldName)" type="number" v-model.trim="sendDataInfo[item.fieldName]"></el-input>
                  <el-input clearable class="input" v-else-if="item.fieldType == 'string'" type="text" v-model.trim="sendDataInfo[item.fieldName]"></el-input>
                  <el-date-picker class="input" v-else-if="item.fieldType == 'date'" v-model="sendDataInfo[item.fieldName]" type="date" placeholder="选择日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd">
                  </el-date-picker>
                  <div v-else-if="item.fieldType == 'imgUrl'">
                     <input style="display: none;" type="file" id="recordExcel" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e,item.fieldName) }" />
                     <ul v-if="sendDataInfo[item.fieldName]" class="upload">
                        <li v-for="(val,key) in sendDataInfo[item.fieldName].split(',')" :key="key" :class="{'active_li':val.indexOf('\.pdf')!=-1||val.indexOf('\.PDF')!=-1}">
                           <i class="el-icon-error del" @click="delRemove(item.fieldName,key)"></i>
                           <cusImage v-if="valFlag(val)" style="width: 40px; height: 40px;" :src="require('@/assets/wenjian.png')">
                           </cusImage>
                           <cusImage v-else style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                           </cusImage>
                        </li>
                        <li>
                           <label for="recordExcel" class="image_label">
                              <i class="el-icon-plus icon"></i>
                           </label>
                        </li>
                     </ul>
                     <ul v-else class="upload">
                        <li>
                           <label for="recordExcel" class="image_label">
                              <i class="el-icon-plus icon"></i>
                           </label>
                        </li>
                     </ul>
                  </div>
               </div>
               <div v-else>
                  <div v-if="item.fieldType == 'imgUrl'">
                     <ul v-if="sendDataInfo[item.fieldName]" class="upload">
                        <li v-for="(val,key) in sendDataInfo[item.fieldName].split(',')" :key="key" :class="{'active_li':val.indexOf('\.pdf')!=-1||val.indexOf('\.PDF')!=-1}">
                           <cusImage v-if="valFlag(val)" style="width: 40px; height: 40px;" :src="require('@/assets/wenjian.png')">
                           </cusImage>
                           <cusImage v-else style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                           </cusImage>
                        </li>
                     </ul>
                  </div>
                  <p class="input" v-else>{{ sendDataInfo[item.fieldName] }}</p>
               </div>
            </el-form-item>
            <el-form-item>
               <label slot="label" :style="$common.labelStyle('摘要')" v-html="$common.htmlLabel('摘要')"></label>
               <el-input clearable :readonly="actionType == 2 || actionType == 4?true:false" class="input" type="textarea" :rows="2" v-model.trim="wfiRemark"></el-input>
            </el-form-item>
         </el-form>
         <div class="details" v-for="(item,index) in this.detailsList" :key="index">
            <div class="details_btn" v-if="actionType == 0||actionType == 1">
               <el-button type="primary" @click="addClick(index,item.name)">新增</el-button>

            </div>
            <el-table height="400" :data="detailsObj[item.name]" border class="detailsTable" :class="{'left_box':actionType == 2}" size="mini">
               <el-table-column align="center" v-for="(tableValye, tableKey) in item.list" :key="tableKey" :prop="tableValye.fieldName" :label="tableValye.fieldName" :show-overflow-tooltip="true"
                                :min-width="tableValye.fieldType=='imgUrl'?270:Number(tableValye.fieldWidth||120)">
                  <template slot-scope="scope">
                     <!-- 系统字段 -->
                     <div v-if="actionType == 0||actionType == 1">
                        <el-date-picker v-if="tableValye.fieldType == 'date'" v-model="scope.row[tableValye.fieldName]" type="date" placeholder="选择日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <el-input clearable style="width: 100%;" v-else-if="tableValye.fieldType == 'number'" @input="calculate(2,tableValye.fieldName,item.name,scope.$index)" type="number"
                                  v-model.trim="scope.row[tableValye.fieldName]"></el-input>
                        <el-input clearable style="width: 100%;" v-else-if="tableValye.fieldType == 'string'" type="text" v-model.trim="scope.row[tableValye.fieldName]"></el-input>
                        <div v-else-if="tableValye.fieldType == 'imgUrl'">
                           <input style="display: none;" type="file" :id="`recordExcel${tableKey}`" multiple :name="`recordExcel${tableKey}`"
                                  @change="(e) => { fileUploadDetails(e.target.files, e.target.files.length, 0, e,tableValye.fieldName,item.name) }" />
                           <ul v-if="scope.row[tableValye.fieldName]" class="upload">
                              <li v-for="(val,key) in scope.row[tableValye.fieldName].split(',')" :key="key" :class="{'active_li':val.indexOf('\.pdf')!=-1||val.indexOf('\.PDF')!=-1}">
                                 <i class="el-icon-error del" @click="delDetailsRemove(tableValye.fieldName,key,scope.$index,item.name)"></i>
                                 <cusImage v-if="valFlag(val)" style="width: 40px; height: 40px;" :src="require('@/assets/wenjian.png')">
                                 </cusImage>
                                 <cusImage v-else style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                 </cusImage>
                              </li>
                              <li>
                                 <label :for="`recordExcel${tableKey}`" @click="detailsObj[`${item.name}Index`]=scope.$index" class="image_label">
                                    <i class="el-icon-plus icon"></i>
                                 </label>
                              </li>
                           </ul>
                           <ul v-else class="upload">
                              <li>
                                 <label :for="`recordExcel${tableKey}`" @click="detailsObj[`${item.name}Index`]=scope.$index" class="image_label">
                                    <i class="el-icon-plus icon"></i>
                                 </label>
                              </li>
                           </ul>
                        </div>
                     </div>
                     <div v-else>
                        <div v-if="tableValye.fieldType == 'imgUrl'">
                           <ul v-if="scope.row[tableValye.fieldName]" class="upload">
                              <li v-for="(val,key) in scope.row[tableValye.fieldName].split(',')" :key="key" :class="{'active_li':val.indexOf('\.pdf')!=-1||val.indexOf('\.PDF')!=-1}">
                                 <cusImage v-if="valFlag(val)" style="width: 40px; height: 40px;" :src="require('@/assets/wenjian.png')">
                                 </cusImage>
                                 <cusImage v-else style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                 </cusImage>
                              </li>
                           </ul>
                        </div>
                        <p v-else>{{scope.row[tableValye.fieldName]  }}</p>
                     </div>
                  </template>
               </el-table-column>
               <el-table-column fixed="right" label="操作" width="145" v-if="actionType == 0||actionType == 1">
                  <template slot-scope="scope">
                     <el-button @click="delClick(scope.$index,item.name)" type="danger" size="mini">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
         </div>
         <div class="floor">
            <el-button v-if="(actionType == 2 || actionType == 4) && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
            <el-button type="primary" @click="initActionBox">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="actionType == 0||actionType == 1">保存</el-button>
            <el-button type="primary" @click="taskClick" v-else-if="actionType==4">审核</el-button>
         </div>
      </div>
      <div class="right_box" v-if="actionType == 2">
         <h3 class="h3">审批流程</h3>
         <el-timeline v-if="reviewNodeList.length > 0">
            <el-timeline-item v-for="(nodeValue, nodeKey) in reviewNodeList" :key="nodeKey" :timestamp="$common.getLocalTime(nodeValue.createTime,true)" placement="top"
                              :icon="nodeValue.auditId == null ? 'el-icon-close': 'el-icon-check'" :type="nodeValue.auditId == null ? 'danger': 'success'">
               <el-card v-if="nodeKey == 0">
                  <h4>{{ nodeValue.appName }}</h4>
                  <p>发起人：{{ nodeValue.orderCreaterName }}</p>
               </el-card>
               <el-card v-else>
                  <h4>{{ nodeValue.nodeName }}</h4>
                  <p>操作人：{{ nodeValue.opmName }}</p>
                  <p v-if="nodeValue.auditState != null" :class="nodeValue.auditState == 0 ? 'auditing_text_red ' : 'auditing_text_green'  ">
                     操作状态：{{ nodeValue.auditState == 0 ? '审核驳回' : '审核通过' }}
                  </p>
                  <p>审核意见：{{ nodeValue.auditRemark ? nodeValue.auditRemark : '暂无信息' }}</p>
               </el-card>
            </el-timeline-item>
         </el-timeline>
         <div v-else style="text-align:center">暂无数据</div>
      </div>
      <el-dialog title="审核" center :visible.sync="dialogVisible" append-to-body>
         <el-form :model="taskData" label-position="top">
            <el-form-item label="审批结果">
               <el-radio-group v-model="taskData.auditState">
                  <el-radio-button :label="1">同意</el-radio-button>
                  <el-radio-button :label="0">不同意</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="审批意见" prop="auditRemark" :rules="[{ required: auditRemarkRequired, message: '请输入审批意见', trigger: ['blur', 'change'] }]">
               <el-input type="textarea" placeholder="请输入内容" v-model="taskData.auditRemark" maxlength="200" show-word-limit>
               </el-input>
            </el-form-item>
         </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitDataAction">提交审批</el-button>
         </span>
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
export default {
   name: 'flowInstanceApplyAction',
   props: ['actionData'],
   data() {
      return {
         actionType: 0,
         actionTitle: "",
         formList: [],
         detailsList: [],
         sendDataInfo: {},
         detailsObj: {},
         imgUrl: window.global_config.BASE_IMG_URL,
         auditRemarkRequired: window.global_config.auditRemarkRequired,
         wfdId: "",
         wfiId: "",
         wfiRemark: "",
         dialogVisible: false,
         taskData: {
            //审核数据
            auditState: 1,
            auditRemark: "",
            businessId: "",
         },
         reviewNodeList: [],
      }
   },
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
   },
   methods: {
      valFlag(val) {
         const lowerVal = val.toLowerCase();
         if (lowerVal.indexOf('.zip') != -1) {
            return true;
         } else if (lowerVal.indexOf('.rar') != -1) {
            return true;
         } else if (lowerVal.indexOf('.doc') != -1) {
            return true;
         } else if (lowerVal.indexOf('.docx') != -1) {
            return true;
         } else if (lowerVal.indexOf('.xls') != -1) {
            return true;
         } else if (lowerVal.indexOf('.xlsx') != -1) {
            return true;
         }
         return false;
      },
      calculate(val, fieldName, type, index) {
         switch (val) {
            case 1:
               this.$set(this.sendDataInfo, fieldName, this.$common.updataNum(fieldName, this.sendDataInfo)[fieldName])
               break;
            case 2:
               this.$set(this.detailsObj[type][index], fieldName, this.$common.updataNum(fieldName, this.detailsObj[type][index])[fieldName])
               break;
            default:
               break;
         }
      },
      openBox() {
         var obj = JSON.parse(this.actionData.wdfForm)
         var data = null
         if (this.actionData.cate == 2 || this.actionData.cate == 4 || this.actionData.cate == 1) {
            data = JSON.parse(this.actionData.wfiContent)
         }
         this.actionType = this.actionData.cate
         this.actionTitle = this.actionData.wfdName
         this.wfdId = this.actionData.wfdId
         this.wfiId = this.actionData.wfiId || ""
         this.detailsList = obj.details || []
         this.detailsList.forEach(item => {
            this.$set(this.detailsObj, item.name, [])
            this.$set(this.detailsObj, `${item.name}Index`, 0)
            if (item.list.filter(val => val.fieldType == 'imgUrl').length > 0) {
               this.$set(this.detailsObj, `${item.name}Flag`, true)
            }
            if (this.actionData.cate == 2 || this.actionData.cate == 4 || this.actionData.cate == 1) {
               this.$set(this.detailsObj, item.name, data.details[item.name])
            }
         })
         this.formList = obj.master || []
         this.formList.forEach(item => {
            this.$set(this.sendDataInfo, item.fieldName, item.defaultValue)
         })
         if (this.actionData.cate == 2 || this.actionData.cate == 4 || this.actionData.cate == 1) {
            for (const key in data.master) {
               this.$set(this.sendDataInfo, key, data.master[key])
            }
            this.wfiRemark = this.actionData.wfiRemark
         }
         this.queryAuditHis()
      },
      async queryAuditHis() {
         const res = await this.$http.flowInstanceauditHis({ ids: [this.actionData.wfiId] })
         console.log(res);
         if (res.status == 200) {
            this.reviewNodeList = res.result
         }
      },
      delRemove(type, key) {
         var arr = this.sendDataInfo[type].split(',')
         arr.splice(key, 1)
         this.sendDataInfo[type] = arr.join()
      },
      async fileUpload(files, length, index, e, type) {
         if (length - 1 >= index) {
            const params = {
               file: files[index]
            }
            const response = await this.$http.uploadFile(params, true)
            if (response.status == 200) {
               var arr = []
               if (this.sendDataInfo[type]) {
                  arr = this.sendDataInfo[type].split(',')
               }
               arr.push(response.result[0].fileUrl)
               this.sendDataInfo[type] = arr.join()
               this.fileUpload(files, length, index + 1, e, type)
            } else {
               e.target.value = ""
               this.$message.error(response.message)
            }
         } else {
            e.target.value = ""
         }
      },
      addClick(index, type) {
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               this.detailsObj[type].push({})
               this.detailsObj[`${type}Index`] = this.detailsObj[type].length - 1
               this.detailsList[index].list.forEach(item => {
                  this.$set(this.detailsObj[type][this.detailsObj[`${type}Index`]], item.fieldName, item.defaultValue)
               })
               console.log(this.detailsObj[type]);

            } else {
               this.$message.error("请完善主信息！")
               return false;
            }
         });
      },
      delClick(index, type) {
         this.detailsObj[type].splice(index, 1)
         this.detailsObj[`${type}Index`] = 0
      },
      delDetailsRemove(fieldName, key, index, type) {
         var arr = this.detailsObj[type][index][fieldName].split(",")
         arr.splice(key, 1)
         this.detailsObj[type][index][fieldName] = arr.join()
      },
      async fileUploadDetails(files, length, index, e, fieldName, type) {
         var detailsIndex = this.detailsObj[`${type}Index`]
         if (length - 1 >= index) {
            const params = {
               file: files[index]
            }
            const response = await this.$http.uploadFile(params, true)
            if (response.status == 200) {
               var arr = []
               console.log(this.detailsObj[type][detailsIndex][fieldName]);
               if (this.detailsObj[type][detailsIndex][fieldName]) {
                  arr = this.detailsObj[type][detailsIndex][fieldName].split(',')
               }
               arr.push(response.result[0].fileUrl)
               this.detailsObj[type][detailsIndex][fieldName] = arr.join()
               this.fileUploadDetails(files, length, index + 1, e, fieldName, type)
            } else {
               e.target.value = ""
               this.$message.error(response.message)
            }
         } else {
            e.target.value = ""
         }
      },
      sendDataAction(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               this.sub()
            } else {
               this.$message.error("请完善主信息！")
               return false;
            }
         });
      },
      async sub() {
         var detailsObj = {}
         this.detailsList.forEach(item => {
            this.$set(detailsObj, item.name, this.detailsObj[item.name])
         })
         var sendData = {
            master: this.sendDataInfo,
            details: detailsObj,
         }
         let params = {
            wfiContent: JSON.stringify(sendData),
            wfdId: this.wfdId,
            wfiRemark: this.wfiRemark,
         }
         let res;
         if (this.actionType == 1) {
            params.wfiId = this.wfiId
            res = await this.$http.flowInstanceupdate(params)
         } else {
            res = await this.$http.flowInstanceAdd(params)
         }
         if (res.status == 200) {
            this.$message.success(res.message)
            this.$emit("drawerCancel", true);
         } else {
            this.$message.error(res.message)
         }
      },
      initActionBox() {
         if (this.actionType == 2 || this.actionType == 4) {
            this.$emit("drawerCancel", false);
            return
         }
         this.$confirm('正在维护该页面的数据, 是否退出?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.$emit("drawerCancel", false);
         }).catch(() => {
         });
      },
      //审批数据
      taskClick() {
         this.dialogVisible = true
         this.taskData = {
            //审核数据
            auditState: 1,
            auditRemark: "",
            businessId: "",
         }
      },
      async submitDataAction() {
         if (this.auditRemarkRequired && !this.taskData.auditRemark) {
            this.$message({
               message: "请输入审批意见",
               type: "warning",
            });
            return;
         }
         this.taskData.businessId = [this.actionData.wfiId];
         let responseData = await this.$http.flowInstanceaudit(this.taskData);
         if (responseData.status == 200) {
            this.$message({
               type: "success",
               message: "操作成功",
            });
            this.$emit("drawerCancel", true);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      async showPrintPlan() {
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(this.actionData.wfiId, 'printData/workFlowPrint', 1635836785253);
         } else {
            return;
         }
      },
   }
}
</script>

<style scoped>
.flowInstanceApplyAction {
   display: flex;
   justify-content: space-between;
   padding-bottom: 40px;
}
.box {
   height: calc(100vh - 45px);
   padding: 10px;
   overflow-y: auto;
}
.right_box {
   flex-shrink: 0;
   width: 300px;
   padding: 10px 10px 10px 0px;
   height: calc(100vh - 45px);
   overflow-y: auto;
}
.right_box .h3 {
   padding-bottom: 10px;
}
.header_title {
   text-align: center;
   height: 40px;
   line-height: 40px;
   background-color: #e4e7ed;
}
.input {
   width: 230px !important;
}
.upload {
   width: 230px;
   list-style: none;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}
.upload li {
   position: relative;
   width: 42px;
   height: 42px;
   margin-right: 5px;
   margin-bottom: 5px;
   border: 1px solid #dedede;
}
.upload .active_li {
   border: none;
}
.image_label {
   display: block;
   width: 42px;
   height: 42px;
}
.upload li:last-child {
   border: none;
}
.upload li:last-child .image_label {
   border: 1px dashed #838383;
}
.upload li:last-child .image_label:hover {
   border: 1px dashed #409eff;
   cursor: pointer;
}
.upload li:last-child:hover .icon {
   color: #409eff;
}
.upload li .icon {
   color: #838383;
   font-size: 20px;
   margin: 10px 0 0 10px;
}
.del {
   display: none;
   position: absolute;
   top: 0px;
   right: 0px;
   font-size: 14px;
   z-index: 99;
   cursor: pointer;
}

.del:hover {
   color: #409eff;
}

.upload li:hover .del {
   display: inline-block;
}
::v-deep #dateinput {
   width: 230px !important;
}
::v-deep .el-date-editor.el-input {
   width: 100%;
}
::v-deep .el-image__error {
   font-size: 7px;
}
::v-deep .cus-image {
   width: 40px !important;
   height: 40px !important;
}
::v-deep .cus-image img {
   width: 40px !important;
   height: 40px !important;
}
.details_btn {
   padding: 10px 0;
}
.floor {
   position: fixed;
   bottom: 0;
   right: 0;
   left: 0;
   width: 100%;
   background-color: #fff;
   height: 40px;
   display: flex;
   align-items: center;
   justify-content: center;
   box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
   z-index: 99;
}
.detailsTable {
   width: 100%;
}
.left_box {
   width: calc(100vw - 340px);
}
</style>